//TODO turn into regular json files

export interface Translations {
	[key: string]: TranslationObject;
}

export interface TranslationObject {
	allAssetsText: string;
	assetsFilter: string;
	unconfiguredAssets: string;
	genericError: string;
}

export const translations: Translations = {
	de: {
		allAssetsText: "Alle sichtbaren Assets",
		assetsFilter: "Assets nach Name oder ID filtern",
		unconfiguredAssets:
			"Sie haben nicht konfigurierte Assets*. Standardmäßig erhalten Sie Benachrichtigungen von diesen Assets, es sei denn, Sie deaktivieren sie.",
		genericError: "Ein Fehler ist aufgetreten. Versuchen Sie es später bitte erneut.",
	},
	zh: {
		allAssetsText: "所有可见的资产",
		assetsFilter: "按名称或 ID 筛选资产",
		unconfiguredAssets: "您有未配置的资产*。默认情况下，您将收到这些资产的通知，除非您将其禁用。",
		genericError: "发生了一个错误。请稍后再试。",
	},
	en: {
		allAssetsText: "All visible assets",
		assetsFilter: "Filter assets by name or ID",
		unconfiguredAssets: "You have unconfigured assets*. By default, you will receive notifications from these assets unless you disable them.",
		genericError: "An error has occurred. Please try again later.",
	},
	fr: {
		allAssetsText: "Tous les actifs visibles",
		assetsFilter: "Filtrer les actifs par nom ou ID",
		unconfiguredAssets: "Vous avez des actifs* non configurés. Par défaut, vous recevrez des notifications de ces actifs, sauf si vous les désactivez.",
		genericError: "Une erreur s'est produite. Veuillez réessayer plus tard.",
	},
	it: {
		allAssetsText: "Tutte le asset visibili",
		assetsFilter: "Filtra gli asset per nome o ID",
		unconfiguredAssets: "Hai asset* non configurati. Per impostazione predefinita, riceverai notifiche da questi asset a meno che tu li disattivi.",
		genericError: "Si è verificato un errore. Per favore riprova più tardi.",
	},
	ko: {
		allAssetsText: "모든 보이는 자산",
		assetsFilter: "이름 또는 ID로 자산 필터링",
		unconfiguredAssets: "구성되지 않은 자산*이 있습니다. 기본적으로 해당 자산의 알림을 받으며, 비활성화하지 않는 한 계속 유지됩니다.",
		genericError: "오류가 발생했습니다. 나중에 다시 시도해 주세요.",
	},
	nl: {
		allAssetsText: "Alle zichtbare items",
		assetsFilter: "Assets filteren op naam of ID",
		unconfiguredAssets: "U heeft niet-geconfigureerde assets*. Standaard ontvangt u meldingen van deze assets, tenzij u ze uitschakelt.",
		genericError: "Er is een fout opgetreden. Probeer het later opnieuw.",
	},
	pl: {
		allAssetsText: "Wszystkie widoczne zasoby",
		assetsFilter: "Filtruj zasoby według nazwy lub ID",
		unconfiguredAssets: "Masz nie skonfigurowane zasoby*. Domyślnie otrzymasz powiadomienia z tych zasobów, chyba że je wyłączysz.",
		genericError: "Wystąpił błąd. Proszę spróbować ponownie później.",
	},
	es: {
		allAssetsText: "Todos los activos visibles",
		assetsFilter: "Filtrar activos por nombre o ID",
		unconfiguredAssets: "Tiene activos* no configurados. De forma predeterminada, recibirá notificaciones de estos activos a menos que los desactive.",
		genericError: "Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde.",
	},
	cs: {
		allAssetsText: "Všechny viditelné položky",
		assetsFilter: "Filtrovat aktiva podle názvu nebo ID",
		unconfiguredAssets: "Máte nekonfigurovaná aktiva*. Ve výchozím nastavení budete dostávat oznámení o těchto aktivech, pokud je nevypnete.",
		genericError: "Došlo k chybě. Zkuste to prosím znovu později.",
	},
	hu: {
		allAssetsText: "Minden látható eszköz",
		assetsFilter: "Eszközök szűrése név vagy azonosító alapján",
		unconfiguredAssets: "Nem konfigurált eszközei* vannak. Alapértelmezés szerint értesítéseket kap ezekről az eszközökről, hacsak nem tiltja le őket.",
		genericError: "Hiba történt. Kérjük, próbálja meg később újra.",
	},
	zh_TW: {
		allAssetsText: "所有可見的資產",
		assetsFilter: "按名稱或 ID 篩選資產",
		unconfiguredAssets: "您有未配置的資產*。預設情況下，您會收到這些資產的通知，除非您將其停用。",
		genericError: "發生了錯誤。請稍後再試。",
	},
	ja: {
		allAssetsText: "すべての表示中のアセット",
		assetsFilter: "名前またはIDで資産をフィルタリングする",
		unconfiguredAssets: "設定されていないアセット*があります。デフォルトでは、これらのアセットから通知を受け取りますが、無効にしない限り維持されます。",
		genericError: "エラーが発生しました。後でもう一度お試しください。",
	},
	pt: {
		allAssetsText: "Todos os ativos visíveis",
		assetsFilter: "Filtrar ativos por nome ou ID",
		unconfiguredAssets: "Tem ativos* não configurados. Por defeito, receberá notificações desses ativos, a menos que os desative.",
		genericError: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
	},
};
